import { Search, Group, MenuBook } from "@mui/icons-material";


export const Appicons = [
    {
        id:0,
        icon: <Search />,
        label: "Search",
        route: "/",
    },
    {
        id:1,
        icon: <Group />,
        label: "About",
        route: "/about",
    },
    {
        id:2,
        icon: <MenuBook />,
        label: "Instructions",
        route: "/instructions",
    },
]